
enum QuizSubType {
    Custom = "Custom",
    MultiChoice = "MultiChoice",
    Scale = "Scale"
}

export { QuizSubType };